import axios from "axios";

// const API_BASE_URL = "http://10.25.53.161"; // Flask API URL
// const API_BASE_URL = "http://10.25.53.164"; // Flask API URL
// const API_BASE_URL = "http://10.194.92.117"; // Flask API URL
// const API_BASE_URL = "http://10.194.92.117:8081"; // Flask API URL
// const API_BASE_URL = "http://10.194.83.67"; // Flask API URL
// const API_BASE_URL = "http://10.194.83.67:8088"; // Flask API URL
// const API_BASE_URL = "http://10.24.248.28"; // Flask API URL
const API_BASE_URL = "https://pragyandashboard.nic.in"; // Flask API URL
// 10.25.53.161:5001/api
// Fetch CAPTCHA
export const fetchCaptcha = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/captcha`);
    return response.data;
  } catch (error) {
    console.error("Error fetching CAPTCHA:", error);
    return null;
  }
};

// Authenticate User
export const loginUser = async (username, password, captchaId, captchaText) => {
  const encodedUsername = btoa(username); // Base64 Encoding
  const encodedPassword = btoa(password);

  return await axios
    .post(
      `${API_BASE_URL}/login`,
      {
        encoded_username: encodedUsername,
        encoded_password: encodedPassword,
        captcha_id: captchaId,
        captcha_text: captchaText,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err;
    });
};

export const AddUser = {
  ADD_USER: `${API_BASE_URL}/api/add_user`,
};
